export const adaptDeliveryInfo = (preorderData) => {
	if (!preorderData) return [];

	const deliveryInfo = preorderData?.purchase_detail?.info?.info_delivery || {};

	return [{
		key: 'delivery-1',
		region: deliveryInfo.region || '-',
		commune: deliveryInfo.commune || '-',
		address: (deliveryInfo.street || '') + ' ' + (deliveryInfo.street_number || ''),
		type_house: deliveryInfo.type_house || '-',
		reference: deliveryInfo.reference || '-',
		number_dpto_house: deliveryInfo.number_dpto_house || '-',
	}];
};
